import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import { Tooltip } from '@cian/ui-kit/tooltip';
import { Attention16 } from '@cian/ui-kit/icons';
import * as styles from './AutoProlong.desktop.css';

interface IAutoProlongDesktopProps {
  value: boolean;
  isDisabled: boolean;
  hint: string;
  onChange(): void;
}

export const AutoProlongDesktop = ({ value, isDisabled, hint, onChange }: IAutoProlongDesktopProps) => {
  const hintIcon = isDisabled ? (
    <Attention16 color="primary_10" display="inline-block" />
  ) : (
    <Tooltip title={hint} theme="white">
      <Attention16 color="focused_15" display="inline-block" />
    </Tooltip>
  );

  return (
    <div className={styles['wrapper']}>
      <Checkbox label="Продлевать автоматически" checked={value} disabled={isDisabled} onChange={onChange} />
      <span className={styles['hint']}>{hintIcon}</span>
    </div>
  );
};
